export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11812.82ac6c66.jpg";